import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "./CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { CssBaseline } from "@material-ui/core";
import TableStatus from "./TableStatus";



const theme = createMuiTheme({
  spacing: 5,
});



export const Users = ({
  selectedOption,
  responseData,
  errors, isLoading,
  users: rows,
  setUsers: setRows,
  setSelectedUserForEdit,
  setSelectedUserForDelete,
  selectedUserForDelete,
}) => {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);

  const [deleteConfirmationText, setDeleteConfirmationText] = useState("");

  const handleCloseDeleteDialog = () => {
    setDeleteConfirmationText("");
    setSelectedUserForDelete({});
  };

  const handleConfirmDelete = () => {
    if (
      deleteConfirmationText.trim().toUpperCase() !== "DELETE" ||
      !selectedUserForDelete?.id
    ) {
      return;
    }

    setLoading(true);

    const requestBody = {
      path: "user",
      query: { id: `${selectedUserForDelete.id}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/auth/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== selectedUserForDelete.id
          );

          return updatedRows;
        });
        setDeleteConfirmationText("");
        setSelectedUserForDelete({});
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationText("");
    setSelectedUserForDelete({});
  };

  const columns = [
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "admin",
      headerName: "Admin",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "maker",
      headerName: "Maker",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "checker",
      headerName: "Checker",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "isMFAEnabled",
      headerName: "MFA Enabled",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "tabs",
      headerName: "Tabs",
      flex: 1,
      minWidth: 350,
    },
    {
      field: "sites",
      headerName: "Sites",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "groups",
      headerName: "Groups",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => setSelectedUserForEdit(params?.row)}
        >
          Edit
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1.2,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          disabled={params?.row?.isOwnProfile || loading}
          onClick={() => {
            setDeleteConfirmationText("");
            setSelectedUserForDelete(params?.row);
          }}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];


  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <div
              className="emms-data-grid-container"
              style={{ padding: "2.5% 10%", overflowX: "auto" }}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>

            <Dialog
              open={Boolean(selectedUserForDelete?.id)}
              onClose={handleCloseDeleteDialog}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Delete User</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                  Are you sure you want to delete {" "}
                  <strong>{selectedUserForDelete?.email || ""}</strong>?
                </DialogContentText>

                <DialogContentText sx={{ mb: 2, color: "error.main" }}>
                  Warning: This action cannot be undone.
                </DialogContentText>

                <TextField
                  autoFocus
                  fullWidth
                  size="small"
                  label="Type DELETE to confirm"
                  value={deleteConfirmationText}
                  onChange={(e) => setDeleteConfirmationText(e.target.value)}
                />
              </DialogContent>

              <DialogActions sx={{ padding: "16px 24px 20px" }}>
                <Button
                  variant="outlined"
                  onClick={handleCancelDelete}
                  disabled={loading}
                  color="error"
                >
                 Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleConfirmDelete}
                  disabled={
                    loading ||
                    deleteConfirmationText.trim().toUpperCase() !== "DELETE"
                  }
                >
                  {loading ? "Deleting..." : "Confirm"}
                </Button>
              </DialogActions>
            </Dialog>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};